import React, { InputHTMLAttributes } from 'react';

type FormFieldProps = {
    label: string;
    name: string;
    value?: string;
    onChange?: (value: string) => void;
    error?: string;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
};

const FormField = ({ label, name, value, onChange, error, type = 'text', placeholder, disabled, required }: FormFieldProps) => {
    return (
        <div className="mb-4">
            <label
                htmlFor={name}
                className="block text-sm font-medium mb-1.5"
                style={{ color: 'var(--text-secondary)' }}
            >
                {label}
            </label>
            <input
                id={name}
                name={name}
                type={type}
                value={value || ''}
                onChange={(e) => onChange?.(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                required={required}
                className="input-base"
            />
            {error && (
                <p className="text-xs mt-1" style={{ color: 'var(--danger)' }}>{error}</p>
            )}
        </div>
    );
};

export default FormField;
